import { render, staticRenderFns } from "./layout-tkani-filters.vue?vue&type=template&id=4a387d9b&scoped=true"
import script from "./layout-tkani-filters.vue?vue&type=script&lang=js"
export * from "./layout-tkani-filters.vue?vue&type=script&lang=js"
import style0 from "./layout-tkani-filters.vue?vue&type=style&index=0&id=4a387d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a387d9b",
  null
  
)

export default component.exports